//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

/**
 * Identical to the original english language config, except we replaced the editor
 * export key to read "Save" rather than "Export" and the exporting key to read
 * "Saving..." instead of "Exporting...".
 */
export default {
  pesdk: {
    adjustments: {
      title: {
        name: 'Adjust',
      },
      text: {
        brightness: 'Brightness',
        saturation: 'Saturation',
        contrast: 'Contrast',
        gamma: 'Gamma',
        clarity: 'Clarity',
        exposure: 'Exposure',
        shadows: 'Shadows',
        highlights: 'Highlights',
      },
    },
    brush: {
      title: {
        name: 'Brush',
      },
      text: {
        size: 'Size',
      },
    },
    camera: {
      title: {
        headline: 'Take a photo!',
      },
      text: {
        webcamUnavailable: 'Unable to display webcam image (Error: ${error})',
      },
    },
    common: {
      title: {
        error: 'An error has occurred',
        imageLoadFail: 'Failed to load image',
      },
      text: {
        color: 'Color',
        loading: 'Loading...',
        imageLoadFail: 'Failed to load the image at ${path}',
      },
      button: {
        back: 'Back',
        cancel: 'Cancel',
      },
    },
    editor: {
      title: {
        zoom: 'Zoom',
        renderingError: 'Error while rendering',
        imageResized_maxMegaPixels: 'Image resized',
        imageResized_maxDimensions: 'Image resized',
      },
      button: {
        export: 'Save',
        backgroundImage: 'Background Image',
        new: 'New',
        undo: 'Undo',
      },
      text: {
        invalidFileType: 'The file type ${fileType} is not supported.',
        exporting: 'Saving...',
        renderingError: 'An error has occurred while rendering the image.',
        resizing: 'Resizing...',
        imageResized_maxMegaPixels: 'Your image exceeds the maximum size of ${maxMegaPixels} megapixels and'
          + ' has therefore been resized to ${width}x${height} pixels.',
        imageResized_maxDimensions: 'Due to hardware limitations your image has been resized to '
          + '${width}x${height} pixels.',
      },
    },
    filter: {
      title: {
        name: 'Filters',
      },
      text: {
        intensity: 'Intensity',
      },
      asset: {
        identity: 'None',
        imgly_lut_celsius: 'Celsius',
        imgly_lut_chest: 'Chest',
        imgly_lut_fixie: 'Fixie',
        imgly_lut_fridge: 'Fridge',
        imgly_lut_front: 'Front',
        imgly_lut_k2: 'K2',
        imgly_lut_mellow: 'Mellow',
        imgly_lut_sin: 'Contrasty',
        imgly_lut_texas: 'Texas',
        imgly_lut_ad1920: '1920 A.D.',
        imgly_lut_ancient: 'Ancient',
        imgly_lut_bleached: 'Bleached',
        imgly_lut_bleachedblue: 'Bleached Blue',
        imgly_lut_blues: 'Blues',
        imgly_lut_blueshadows: 'Blue Shadows',
        imgly_lut_breeze: 'Breeze',
        imgly_lut_bw: 'B & W',
        imgly_lut_classic: 'Classic',
        imgly_lut_colorful: 'Colorful',
        imgly_lut_cool: 'Cool',
        imgly_lut_cottoncandy: 'Cotton Candy',
        imgly_lut_creamy: 'Creamy',
        imgly_lut_eighties: 'Eighties',
        imgly_lut_elder: 'Elder',
        imgly_lut_evening: 'Evening',
        imgly_lut_fall: 'Fall',
        imgly_lut_food: 'Food',
        imgly_lut_glam: 'Glam',
        imgly_lut_gobblin: 'Gobblin',
        imgly_lut_highcarb: 'High Carb',
        imgly_lut_highcontrast: 'High Contrast',
        imgly_lut_k1: 'K1',
        imgly_lut_k6: 'K6',
        imgly_lut_kdynamic: 'KDynamic',
        imgly_lut_keen: 'Keen',
        imgly_lut_lenin: 'Lenin',
        imgly_lut_litho: 'Litho',
        imgly_lut_lomo100: 'Lomo 100',
        imgly_lut_lucid: 'Lucid',
        imgly_lut_neat: 'Neat',
        imgly_lut_nogreen: 'No Green',
        imgly_lut_orchid: 'Orchid',
        imgly_lut_pale: 'Pale',
        imgly_lut_pitched: 'Pitched',
        imgly_lut_plate: 'Plate',
        imgly_lut_pola669: 'Pola 669',
        imgly_lut_polasx: 'Pola SX',
        imgly_lut_pro400: 'Pro 400',
        imgly_lut_quozi: 'Quozi',
        imgly_lut_sepiahigh: 'Sepia High',
        imgly_lut_settled: 'Settled',
        imgly_lut_seventies: 'Seventies',
        imgly_lut_soft: 'Soft',
        imgly_lut_steel: 'Steel',
        imgly_lut_summer: 'Summer',
        imgly_lut_sunset: 'Sunset',
        imgly_lut_tender: 'Tender',
        imgly_lut_twilight: 'Twilight',
        imgly_lut_winter: 'Winter',
        imgly_lut_x400: 'X400',
        imgly_filters_analog: 'Analog',
        imgly_filters_bw: 'Black & White',
        imgly_filters_retro: 'Retro',
        imgly_filters_special: 'Special',
        imgly_filters_summer: 'Summer',
        imgly_filters_winter: 'Winter',
        all: 'All',
      },
    },
    focus: {
      title: {
        name: 'Focus',
      },
      text: {
        blurRadius: 'Blur radius',
      },
      button: {
        none: 'None',
        radial: 'Radial',
        mirrored: 'Mirrored',
      },
    },
    frame: {
      title: {
        name: 'Frame',
      },
      text: {
        scale: 'Scale',
      },
      button: {
        none: 'None',
      },
      asset: {
        imgly_frame_dia: 'Dia',
        imgly_frame_art_decor: 'Art Decor',
        imgly_frame_black_passepartout: 'Black Passepartout',
        imgly_frame_lowpoly_shadow: 'Low Poly',
        imgly_frame_wood_passepartout: 'Wood Passepartout',
      },
    },
    library: {
      title: {
        searchResults: 'Search results for \'${query}\'',
        photoRollLoadFail: 'Failed to load Photo Roll',
      },
      text: {
        photoRollLoadFail: 'Failed to load photos for the photo roll: ${error}',
        noSearchResults: 'Sorry, but we couldn\'t find any photos for <strong>${query}</strong>.',
      },
      placeholder: {
        search: 'Search for photos',
      },
    },
    splash: {
      button: {
        upload: 'Upload your image',
      },
      title: {
        photoRoll: 'Free stock footage',
        webcam: 'Webcam',
      },
      text: {
        photoRoll: 'Select from thousands of Free Stock Photos',
        upload: 'Upload a picture from your library or just drag and drop',
        webcam: 'Take a picture with your webcam or phone',
      },
    },
    sticker: {
      title: {
        name: 'Sticker',
        loadingStickersFailed: 'Failed to load stickers',
      },
      asset: {
        all: 'All',
        imgly_sticker_emoticons: 'Emoticons',
        imgly_sticker_shapes: 'Shapes',
      },
    },
    text: {
      title: {
        name: 'Text',
        loadingFontsFailed: 'Failed to load fonts',
      },
      text: {
        loadingFontsFailed: 'Some fonts might not be available.',
      },
      button: {
        size: 'Size',
        font: 'Font',
        alignment: 'Alignment',
        foreground: 'Foreground',
        background: 'Background',
        takeToFront: 'To Front',
      },
      placeholder: {
        defaultText: 'Double-click to edit',
      },
    },
    transform: {
      title: {
        name: 'Transform',
      },
      button: {
        none: 'Original',
      },
      text: {
        rotation: 'Rotation',
      },
      asset: {
        imgly_transform_common_custom: 'Custom',
        imgly_transform_common_square: 'Square',
        'imgly_transform_common_4-3': '4:3',
        'imgly_transform_common_16-9': '16:9',
        imgly_transform_facebook_ad: 'FB Ad',
        imgly_transform_facebook_post: 'FB Post',
        imgly_transform_facebook_cover: 'FB Cover',
        imgly_transform_facebook_profile: 'FB Profile',
      },
    },
  },
};
